import htmlToText from 'html-to-text';
import React, { Component, Fragment } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Field, reduxForm, reset } from 'redux-form';
import {
  Button,
  Col,
  Form,
  FormGroup,
  Modal,
  ModalBody,
  ModalHeader,
  Row
} from 'shards-react';
import { sendEmail } from '../../../../pages/Dashboard/Complaint/complaintActions';
import TextInput from '../../../form/TextInput';
import { closeModal } from '../../modalActions';

const mapState = (state, ownProps) => ({
  initialValues: { to: ownProps.complaint.agent.email },
  id: ownProps.complaintId,
  user: state.firebase.profile,
  complaint: ownProps.complaint
});

const actions = {
  sendEmail,
  closeModal
};

class ReceipientEmailForm extends Component {
  state = {
    toWhom: '',
    to: '',
    options: []
  };
  renderQuill = ({ input }) => {
    return (
      <ReactQuill
        onChange={(newValue, delta, source) => {
          input.onChange(newValue);
        }}
        onBlur={(range, source, quill) => {
          input.onBlur(quill.getHTML());
        }}
      />
    );
  };
  onFormSubmit = e => {
    e.id = this.props.complaint.id;
    e.status = this.props.complaint.status;
    e.text = htmlToText.fromString(e.html);
    e.to = this.props.complaint.agent.email;

    this.props.sendEmail(e).then(() => {
      this.props.dispatch(reset({ form: 'emailForm' }));
      this.props.closeModal();
    });
  };

  render() {
    const {
      complaint,
      pristine,
      submitting,
      closeModal,
      handleSubmit,
      agentEmail
    } = this.props;
    return (
      <Modal
        className='col-md-8 col-lg-8'
        open={true}
        toggle={closeModal}
        modalClassName='modal'
        fade={true}
        role='dialog'
      >
        <ModalHeader className='bg-primary1 text-white'>Email</ModalHeader>
        <ModalBody>
          {complaint && complaint.agent.email ? (
            <Form onSubmit={handleSubmit(this.onFormSubmit)}>
              <Fragment>
                <Row>
                  <Col>
                    <FormGroup>
                      <label htmlFor='to'> Recipient</label>
                      <div> NCCC </div>
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup>
                      <label htmlFor='subject'>Subject</label>
                      <Field name='subject' type='text' component={TextInput} />
                    </FormGroup>
                  </Col>
                </Row>

                <Field name='html' type='textarea' component={this.renderQuill}>
                  <div className='my-editing-area' />
                </Field>
              </Fragment>
              <div className='home-buttons d-flex w-100 justify-content-between'>
                <Button
                  type='cancel'
                  theme='danger'
                  onClick={() => closeModal()}
                >
                  Cancel
                </Button>
                <Button
                  type='submit'
                  theme='success'
                  disabled={
                    pristine || submitting || !complaint.agent.email.length > 4
                  }
                >
                  Submit
                </Button>
              </div>
            </Form>
          ) : (
            <Fragment>
              No agent assigned yet. Please wait till agent assignment to start
              emailing. Please take note that agent assignment might take up to
              14 days due overwhelming complaints received.
              <div className='home-buttons d-flex w-100 justify-content-between mt-2'>
                <Button
                  type='cancel'
                  theme='danger'
                  onClick={() => closeModal()}
                >
                  Cancel
                </Button>
              </div>
            </Fragment>
          )}
        </ModalBody>
      </Modal>
    );
  }
}

export default compose(
  connect(mapState, actions),
  reduxForm({ form: 'emailForm' })
)(ReceipientEmailForm);
